import React from 'react';

function WaterTrackTOS() {
  return (
    <div className="water-track-tos-page">
      <section className="tos-hero">
        <div className="container">
          <h1 className="tos-title">Terms of Service</h1>
          <p className="tos-subtitle">Water Track Daily H2O</p>
          <p className="tos-subtitle">Last updated: September 2025</p>
        </div>
      </section>

      <section className="tos-content">
        <div className="container">
          <div className="tos-text">
            <div className="tos-section">
              <h2>1. Introduction</h2>
              <p>
                Welcome to Water Track Daily H2O. These Terms of Service ("Terms") govern your use of our mobile
                application. By accessing or using Water Track Daily H2O, you agree to be bound by these Terms.
                If you do not agree, please do not use the app.
              </p>
            </div>

            <div className="tos-section">
              <h2>2. Use of the App</h2>
              <p>
                Water Track Daily H2O is intended for personal, non-commercial use only. You agree not to misuse
                the app, attempt unauthorized access, or interfere with its normal operation.
              </p>
              <p>
                The app is a tool to assist with personal hydration tracking. It does not provide medical,
                health, or professional advice.
              </p>
            </div>

            <div className="tos-section">
              <h2>3. User Data & Privacy</h2>
              <p>
                All hydration data you enter into Water Track Daily H2O is stored <strong>locally on your
                device</strong>. We do not collect, transmit, or share your data.
              </p>
              <p>
                For more details, please review our Privacy Policy.
              </p>
            </div>

            <div className="tos-section">
              <h2>4. Intellectual Property</h2>
              <p>
                Water Track Daily H2O and all related content are owned by Cary Schweitzer and protected by
                intellectual property laws. You may not copy, modify, distribute, or reverse-engineer
                the app without prior written consent.
              </p>
            </div>

            <div className="tos-section">
              <h2>5. Disclaimers</h2>
              <p>
                Water Track Daily H2O is provided "as is" without warranties of any kind. We do not guarantee
                that the app will meet your expectations, be error-free, or operate without interruption.
              </p>
            </div>

            <div className="tos-section">
              <h2>6. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Cary Schweitzer shall not be liable for any
                indirect, incidental, or consequential damages resulting from your use of Water Track Daily H2O.
              </p>
            </div>

            <div className="tos-section">
              <h2>7. Changes to Terms</h2>
              <p>
                We may update these Terms from time to time. Updates will be reflected within the app
                or linked on our website.
              </p>
            </div>

            <div className="tos-section">
              <h2>8. Apple App Store Terms</h2>
              <p>
                If you downloaded this app from the Apple App Store, your use of the app is also subject to 
                Apple's Licensed Application End User License Agreement. In case of any conflict between these 
                Terms and Apple's terms, Apple's terms will prevail for iOS users.
              </p>
              <p>
                You can review Apple's terms at: 
                <a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank" rel="noopener noreferrer">
                  Apple's Licensed Application End User License Agreement
                </a>
              </p>
            </div>

            <div className="tos-section">
              <h2>9. Contact Us</h2>
              <p>
                If you have any questions about these Terms, contact us at
                <a href="/contact"> Contact Page</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WaterTrackTOS;